export var searchBeanMap = {};
export function getDefaultAgencySearchBean() {
  return {
    placeId: -1,
    placeType: "",
    cityId: -1,
    zoneId: -1,
    localityId: -1,
    provinceId: -1,
    regionId: -1,
    localityIdList: [],
    zoneIdList: [],
    cityDisplayName: "",
    cityURL: "",
    zoneURL: "",
    agencyName: "",
    franchiseId: -1,
    categoryAssociationId: -1,
    IDList: [],
    subscriptionTypes: [],
    polygonFromMap: "",
    latitude: -1,
    longitude: -1,
    isPrestigious: false
  };
}